<template>
    <div class="flex items-center q-ml-xl q-mr-xl" style="margin-top: 46px;">
        <el-container class="bg-color-white" style="width: 80%;">
            <el-main>
                <el-container>
                    <el-aside width="200px" class="text-left q-mr-md">
                        <el-menu
                                :default-active="active"
                                class="el-menu-vertical-demo"
                                @select="menuHandleSelect"
                        >
<!--                            <el-menu-item index="1">-->
<!--                                <i class="el-icon-menu"></i>-->
<!--                                <span slot="title">客户档案</span>-->
<!--                            </el-menu-item>-->
                            <el-menu-item index="customer_solution">
                                <i class="el-icon-document"></i>
                                <span slot="title">项目方案</span>
                            </el-menu-item>
                            <el-menu-item index="solution">
                                <i class="el-icon-setting"></i>
                                <span slot="title">方案商机</span>
                            </el-menu-item>
                        </el-menu>
                    </el-aside>
                    <el-main style="padding: 0px; width: 100%;">
                        <router-view />
                    </el-main>
                </el-container>

            </el-main>
        </el-container>
    </div>

</template>

<script>
    // import FileSaver from 'file-saver'
    // import XLSX from 'xlsx'
    // import sha1 from "hmacsha1";
    // import md5 from "js-md5";
    // import htaxios from 'axios'
    export default {
        // 管理主页
        name: 'ManageHomepage',
        data () {
            return {
                project: '',
                dealer: '',//经销商
                cTerminal:'',//C端客户
                principal: '',// 负责人
                time: '',//时间
                dialogVisible: false,
                dialogTitle: '',
                principalDialog: false,
                input: '',//负责人
                active: 'customer_solution',
            }
        },
        mounted() {
            this.active = this.$route.name;
        },
        methods: {
            menuHandleSelect(key){
                console.log(key)
                // if (key == 2){
                //     console.log('跳转到2')
                //     this.$router.push({name:'solution_configuration',params:{title:'方案配置'}})
                // }
                // var keyValue = parseInt(key)
                // switch (keyValue) {
                //     case 1:
                //         this.$router.push({name:'customer_solution',params:{title:'方案管理'}})
                //         break
                //     case 2:
                //         this.$router.push({name:'solution',params:{title:'设计师项目管理'}})
                //         break
                //     default:
                //         break
                // }
                if (key === 'customer_solution'){
                    this.$router.push({name:'customer_solution',params:{title:'方案管理'}})
                }else if(key === 'solution'){
                    this.$router.push({name:'solution',params:{title:'设计师项目管理'}})
                }
            },

        }
    }
</script>

<style scoped>

</style>
